const planningRouters = [
  {
    path: "/planning/:token/index",
    name: 'planning-page',
    component: () => import(/* webpackChunkName: "planning" */ '@/views/planning/index')
  },
  {
    path: "/planning/:token/detail",
    name: 'planning-detail',
    component: () => import(/* webpackChunkName: "planning" */ '@/views/planning/page/planning-detail')
  },
  {
    path: "/planning/report/:token",
    name: 'planning-report',
    component: () => import(/* webpackChunkName: "planning" */ '@/views/planning/page/planning-report')
  }
]

export default planningRouters
